export type RuntimeEvidenceSeverity =
  | 'info'
  | 'warning'
  | 'error'
  | 'critical';

export interface RuntimeEvidenceRecord {
  readonly id: string;
  readonly governor: string;
  readonly source: string;
  readonly event: string;
  readonly severity: RuntimeEvidenceSeverity;
  readonly timestamp: string;
  readonly metadata: Readonly<Record<string, unknown>>;
}

const MAX_BUFFER_SIZE = 1000;

const ringBuffer: (RuntimeEvidenceRecord | null)[] =
  new Array(MAX_BUFFER_SIZE).fill(null);

let writeIndex = 0;
let totalCount = 0;

export function recordRuntimeEvidence(
  record: RuntimeEvidenceRecord
): void {
  ringBuffer[writeIndex] = Object.freeze({
    ...record,
    metadata: Object.freeze({ ...record.metadata }),
  });

  writeIndex = (writeIndex + 1) % MAX_BUFFER_SIZE;

  if (totalCount < MAX_BUFFER_SIZE) {
    totalCount += 1;
  }
}

export function getRuntimeEvidence():
  readonly RuntimeEvidenceRecord[] {

  const result: RuntimeEvidenceRecord[] = [];
  const start = totalCount === MAX_BUFFER_SIZE ? writeIndex : 0;

  for (let i = 0; i < totalCount; i += 1) {
    const item = ringBuffer[(start + i) % MAX_BUFFER_SIZE];

    if (item) {
      result.push(item);
    }
  }

  return Object.freeze(result);
}

export function getRuntimeEvidenceCount(): number {
  return totalCount;
}

export function purgeRuntimeEvidenceForOperator(
  operatorToken: string,
  expectedOperatorToken: string
): void {
  if (
    !expectedOperatorToken ||
    operatorToken !== expectedOperatorToken
  ) {
    throw new Error(
      'CRITICAL AUTHORITY VIOLATION: Unauthorized telemetry purge attempted.'
    );
  }

  ringBuffer.fill(null);
  writeIndex = 0;
  totalCount = 0;
}
